import { useEffect, useRef } from 'react';

import { useAppsFlyer } from '@order/integrations-appsflyer';
import { useTelemetry } from '@order/Telemetry';

import { usePostLoginRedirectHref } from '../../context/AuthMachine';
import { useCustomer } from '../../context/Customer';

// ─────────────────────────────────────────────────────────────────────────────

export const useTrackSignInSuccess = () => {
  const postLoginRedirectHref = usePostLoginRedirectHref();
  const { customer } = useCustomer();
  const { track } = useTelemetry();
  const { logLoginEvent } = useAppsFlyer();

  // ─── Refs ────────────────────────────────────────────────────────────

  const trackRef = useRef(track);
  const logLoginEventRef = useRef(logLoginEvent);

  trackRef.current = track;
  logLoginEventRef.current = logLoginEvent;

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(() => {
    if (!postLoginRedirectHref || !customer.id) return;

    trackRef.current('sign-in.success', { userId: customer.id });
    logLoginEventRef.current();
  }, [postLoginRedirectHref, customer.id]);
};
